// extracted by mini-css-extract-plugin
export default {"wrap":"gp-z","logoContainer":"hp-z","brandImg":"ip-z","logoImg":"jp-z","logoButton":"kp-z"};